import Chart = require("dojox/charting/Chart");
import Chart2D = require("dojox/charting/Chart2D");
import Pie = require("dojox/charting/plot2d/Pie");
import Lines = require("dojox/charting/plot2d/Lines");
import Theme = require("dojox/charting/themes/Chris");import Geometry = require("esri/geometry/Geometry");

import * as geometryEngine from 'esri/geometry/geometryEngine'
import Graphic = require("esri/Graphic");
import MapImageLayer = require("esri/layers/MapImageLayer");
import PopupTemplate = require("esri/PopupTemplate");
import Query = require("esri/rest/support/Query");
import MapView = require("esri/views/MapView");
import * as baseGroup from "../../data/Layers/baseGroup";
import ToolBar from "../Toolbar";
import ToolButton from "./toolButton";
import * as pavement from  '../../data/Layers/pavement';
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
import GraphicsLayer = require('esri/layers/GraphicsLayer');
import {setClickPoint, clearGraphicType} from '../App/setupView';
import watchUtils = require('esri/core/watchUtils');
import Point = require('esri/geometry/Point');
import TextContent = require('esri/popup/content/TextContent');
import FieldInfo = require('esri/popup/FieldInfo');
import FieldsContent = require('esri/popup/content/FieldsContent');
import Content = require('esri/popup/content/Content');

// DataReportTool

export default class DataReportTool extends ToolButton {
  private eventHandler: IHandle;
  private featuresHist: Graphic[]|undefined;
  private drawLayer: GraphicsLayer;
  private historicalCSV = "";
  private historicalFilename = "";

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    if (this.eventHandler) {
      this.eventHandler.remove();
    }
    document.body.style.cursor = "default";
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("DataReportTool start")
    try {
      this.iconDiv = event.currentTarget;
      this.drawLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;

      if (this.toolbar && this.view) {
        this.toolbar.setActiveTool(this as ToolButton);
        this.view.focus();
        document.body.style.cursor = "crosshair";
        this.eventHandler = this.view.on("click", mouseEvent => {
          mouseEvent.stopPropagation();
          document.body.style.cursor = "wait";

          this.view.popup.visible = false;
          this.view.popup.clear();

          const query = new Query({
            // objectIds: [189280],
            geometry: mouseEvent.mapPoint,
            spatialRelationship: "intersects",
            distance: 50,
            units: "meters",
            outFields: ["*"],
            returnGeometry: true
          });

          // console.log("start raods query");
          baseGroup.idotRoadsLayer
            .queryFeatures(query)
            .then(featureSet => {
              if (featureSet.features.length > 0) {
                let closestDist = 999999;
                let closestIndex = 0;
                featureSet.features.forEach((value, index) => {
                  const dist = geometryEngine.distance(mouseEvent.mapPoint, value.geometry, "meters");
                  if (dist < closestDist) {
                    closestDist = dist;
                    closestIndex = index;
                  }
                });

                this.queryProgramData(mouseEvent.mapPoint, featureSet.features[closestIndex]);
              } else {
                console.log("no roads retruned");
                alert("No road found. Try again.");
                document.body.style.cursor = "crosshair";
              }
            })
            .catch(reason => {
              document.body.style.cursor = "crosshair";
              console.log("Error in Data Report tool ", reason);
            });
        });
      }
    } catch (error) {
      console.error("Error: in DataReportTool " + +error.message);
      document.body.style.cursor = "crosshair";
    }
  }

  private _highlightGeometry(geometry: Geometry) {
    try {
      if (geometry.extent) {
        const selectedGraphic = new Graphic({
          geometry,
          attributes: { type: "history" },
          symbol: new SimpleLineSymbol({
            color: [0, 157, 217],
            width: 3 // points
          })
        });
        this.drawLayer.add(selectedGraphic);
      }
    } catch (error) {
      console.error("Error: in _highlightGeometry " + error.message);
    }
  }

  private queryProgramData(inGeometry: Point, feature: Graphic) {
    try {
      const selectLayerList = document.getElementById("selectLayerList") as HTMLSelectElement;
      const layerId: any = selectLayerList.value;
      const layer: __esri.Layer = this.view.map.findLayerById(layerId);
      let willQuery = false;

      const queryHist = new Query({
        geometry: inGeometry,
        spatialRelationship: "intersects",
        distance: 50,
        units: "meters",
        orderByFields: ["CRS_YR Desc"],
        outFields: ["*"],
        returnGeometry: true
      });

      pavement.roadConditionHistoricalLayer
      .queryFeatures(queryHist)
      .then(({features:histFeatures}) => {
        // console.log("Historical ", histFeatures);
        // histFeatures.forEach(histFeature => {
        //   console.log("\n\nYear ", histFeature.attributes.CRS_YR, " CRS ", histFeature.attributes.CRS_WITH, " DTRESS ", histFeature.attributes.DTRESS_WTH, " IRI ", histFeature.attributes.IRI_WITH, " RUT ", histFeature.attributes.RUT_WITH);
        // });

        if (layer) {
          const query = new Query({
            geometry: inGeometry,
            spatialRelationship: "intersects",
            distance: 50,
            units: "meters",
            outFields: ["*"],
            where: "GISRouteKe = '" + feature.attributes.INVENTORY + "'",
            returnGeometry: false
          });
  
          if (layer instanceof MapImageLayer) {
            const mapImageLayer: MapImageLayer = layer as MapImageLayer;
            if (mapImageLayer && mapImageLayer.sublayers.length > 0) {
              let mapImageSelectedLayer = mapImageLayer.sublayers.getItemAt(0);
              // If it's one of the program layers, use the 3rd layer as the selectable layer (i.e. CRS Marked);
              if (mapImageLayer.sublayers.length > 2) {
                mapImageSelectedLayer = mapImageLayer.sublayers.getItemAt(1);
              }
              if (
                mapImageSelectedLayer &&
                (mapImageSelectedLayer.title.indexOf("MYP") === 0 ||
                  mapImageSelectedLayer.title.indexOf("FTR") === 0 ||
                  mapImageSelectedLayer.title.indexOf("Annual") === 0)
              ) {
                // console.log("  Sublayer = ", mapImageSelectedLayer.title);
                willQuery = true;
                mapImageSelectedLayer
                  .queryFeatures(query)
                  .then(({ features }) => {
                    setClickPoint(inGeometry);
                    this.loadPopupTemplate(feature, features, histFeatures);
                  })
                  .catch(error => {
                    console.error("Error in queryProgramData", error);
                    document.body.style.cursor = "crosshair";
                  });
              }
            }
          }
        }
        if (!willQuery) {
          setClickPoint(inGeometry);
          this.loadPopupTemplate(feature, undefined, histFeatures);
        }

      }).catch(error => {
        console.error("Error in queryProgramData", error);
        document.body.style.cursor = "crosshair";
      });
    } catch (error) {
      console.error("Error: in queryProgramData " + error.message);
    }
  }



  private unselectHistory(event: MouseEvent) {
    clearGraphicType(this.view, "history");
  }

  private selectHistory(event: MouseEvent) {
    if (event.srcElement) {
      const td = event.srcElement as HTMLTableCellElement;
      if (td.parentElement) {
        const tr = td.parentElement as HTMLTableRowElement;
        const feature = Number(tr.id.slice(8));
        // console.log(" history mouse over ", feature);
        if (this.featuresHist && this.featuresHist.length > feature) {
          const graphic = this.featuresHist[feature];
          this._highlightGeometry(graphic.geometry);
        }
      }
    }
  }

  private addSelectLinks(features:Graphic[], selectHistory:any, highlightGeometry:any) {
    try {
      // console.log("addSelectLinks");
      if (this.featuresHist && this.featuresHist.length > 0) {
        this.featuresHist.forEach((feature, index) => {
          const tr = document.getElementById("FEATURE_" + index) as HTMLTableRowElement;
          if (tr) {
            tr.onmouseover = this.selectHistory.bind(this);
            tr.onmouseout = this.unselectHistory.bind(this);
          }
        })
      }
    } catch (error) {
      console.log("Error in addSelectLinks", error.message);            
    }
}

private addPieChart(feature: Graphic) {
  try {
    // console.log ("addPieChart ");

    const total =
      (feature.attributes.AADT) /
      100;
    if (total > 0) {
      const other = (feature.attributes.AADT - feature.attributes.MU_VOL - feature.attributes.SU_VOL) / total;
      const mu = feature.attributes.MU_VOL / total;
      const su = feature.attributes.SU_VOL / total;

      // console.log(' chartNode = ', chartNode);

      const textContents = document.getElementsByClassName("esri-feature__text");
      for (let i=0; i<textContents.length; i++) {
         const ele = textContents[i] as HTMLDivElement;
         if (ele.innerText === "Traffic") {
           ele.innerHTML = "<div><div id='chartNode'></div></div>";
         }
      }

      const pieChart = new Chart("chartNode", {
        title: "Traffic",
        titleFont: "normal normal normal 12pt Arial",
        titleFontColor: "green",
        titleGap: 5

      });

      if (pieChart) {
        pieChart.setTheme(Theme);

        pieChart.addPlot("default", {
          type: Pie, 
          // radius: 500,
          // labelStyle: "columns",
          fontColor: "black",
          labelOffset: 30
        });

        pieChart.addSeries("Series A", [
          {
            y: other,
            text: "<strong>Other " + other.toFixed(1) + "%</strong>",
            fill: "lightblue"
          },
          {
            y: mu,
            text: "<strong>MU " + mu.toFixed(1) + "%</strong>",
            fill: "lightgreen"
          },
          {
            y: su,
            text: "<strong>SU " + su.toFixed(1) + "%</strong>",
            fill: "lightpink"
          }
        ]);
        //    new Tooltip(pieChart, "default", {
        //         text(o:any) {
        //             return o.run.data[o.index].text;
        //         }
        //    });

        pieChart.render();
        // Legend:
        // const legend = new Legend({
        //     chartRef: pieChart,
        //     horizontal: false
        // }, 'legendNode');
      }
    }
  } catch (error) {
    console.error("Error: in addPieChart " + error.message);
  }
}

private addCRSChart(programFeatures: Graphic[]) {
  try {
    // console.log ("addCRSChart ");

      const textContents = document.getElementsByClassName("esri-feature__text");
      for (let i=0; i<textContents.length; i++) {
         const ele = textContents[i] as HTMLDivElement;
         if (ele.innerText === "CRS Chart") {
           ele.innerHTML = "<div><div id='crsChartNode'></div></div>";
         }
      }

      const lineChart = new Chart2D("crsChartNode", {
        title: "CRS History",
        titleFont: "normal normal normal 15pt Arial",
        titleFontColor: "green"
      });

      lineChart.setTheme(Theme);


      if (lineChart) {
        
        const crsWithSeries : Array<{x:number, y:number}> = [];
        const crsOppSeries : Array<{x:number, y:number}> = [];

        let minX = 5555;
        let maxX = 0;
        let maxY = 0
        programFeatures.forEach((programFeature, index) => {
          minX = Math.min(minX, programFeature.attributes.CRS_YR);
          maxX = Math.max(maxX, programFeature.attributes.CRS_YR);
          maxY = Math.max(maxY, programFeature.attributes.CRS_WITH);
          maxY = Math.max(maxY, programFeature.attributes.CRS_OPP);
          if (programFeature.attributes.CRS_WITH > 0) {
            crsWithSeries.push({x : programFeature.attributes.CRS_YR, y: programFeature.attributes.CRS_WITH});
          }
          if (programFeature.attributes.CRS_OPP > 0) {
            crsOppSeries.push({x : programFeature.attributes.CRS_YR, y: programFeature.attributes.CRS_OPP});
          }
        });

        lineChart.addPlot("default", {
          type: Lines, 
          hAxis: "x", 
          vAxis: "y", 
          markers: true, 
          labels: true
        });

        lineChart.addAxis("x", {title: "Year", titleOrientation: "away", majorTickStep: 5, minorTickStep: 1, titleGap: 5, natural: true, min: minX - 1, max: maxX + 1});
        lineChart.addAxis("y", {title: "CRS", includeZero: true, fixUpper: "major", vertical: true, titleGap: 5, max: maxY + 1});
        if (crsWithSeries.length > 0) {
          lineChart.addSeries("CRS WITH", crsWithSeries);
        }
        if (crsOppSeries.length > 0) {
          lineChart.addSeries("CRS OPP", crsOppSeries);
        }

        lineChart.render();

      }
    }
    catch (error) {
    console.error("Error: in addCRSChart " + error.message);
  }
}

  private getPavementTableFromHistory(roadFeature: Graphic): string {
    if (roadFeature && roadFeature.attributes) {
      const tableStr = "Pavement Condition<br/><br/>" + 
      '<table class="popupTable">' + 
      '<tr>' +
      '  <th>Type</th>' +
      '  <th>With</th>' +
      '  <th>Opp</th>' +
      '  <th>Year</th>' +
      '</tr>' +
      '<tr>' +
      '  <td>CRS</td>' +
      '  <td>' + roadFeature.attributes.CRS_WITH.toFixed(1) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_OPP.toFixed(1) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>Distress</td>' +
      '  <td>' + roadFeature.attributes.DTRESS_WTH + '</td>' +
      '  <td>' + roadFeature.attributes.DTRESS_OPP + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>IRI</td>' +
      '  <td>' + roadFeature.attributes.IRI_WITH + '</td>' +
      '  <td>' + roadFeature.attributes.IRI_OPP + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>RUT</td>' +
      '  <td>' + roadFeature.attributes.RUT_WITH.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.RUT_OPP.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>Faulting</td>' +
      '  <td>' + roadFeature.attributes.FAULT_WITH.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.FAULT_OPP.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '</table>'

      return tableStr;

    } else {
      return "";
    }
  }

  private getPavementTable(roadFeature: Graphic|undefined):string {
    if (roadFeature && roadFeature.attributes) {
      const tableStr = "Pavement Condition<br/><br/>" + 
      '<table class="popupTable">' + 
      '<tr>' +
      '  <th>Type</th>' +
      '  <th>With</th>' +
      '  <th>Opp</th>' +
      '  <th>Year</th>' +
      '</tr>' +
      '<tr>' +
      '  <td>CRS</td>' +
      '  <td>' + roadFeature.attributes.CRS_WITH.toFixed(1) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_OPP.toFixed(1) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>Distress</td>' +
      '  <td>' + roadFeature.attributes.DTRESS_WTH + '</td>' +
      '  <td>' + roadFeature.attributes.DTRESS_OPP + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>IRI</td>' +
      '  <td>' + roadFeature.attributes.IRI_WITH + '</td>' +
      '  <td>' + roadFeature.attributes.IRI_OPP + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>RUT</td>' +
      '  <td>' + roadFeature.attributes.RUT_WITH.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.RUT_OPP.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '<tr>' +
      '  <td>Faulting</td>' +
      '  <td>' + roadFeature.attributes.FAULT_WITH.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.FAULT_OPP.toFixed(2) + '</td>' +
      '  <td>' + roadFeature.attributes.CRS_YR + '</td>' +
      '</tr>' +
      '</table>'

      return tableStr;

    } else {
      return "";
    }
  }

  private getHistoricalPavementTable(pavementFeatures: Graphic[]|undefined):string {
    if (pavementFeatures && pavementFeatures.length > 0) {
      let tableStr = "Historical Road Condition (With|Opposing)<br/><br/>" + 
      '<table class="popupTable" style="font-size: 10px">' + 
      '<tr>' +
      '  <th>Year</th>' +
      '  <th>CRS</th>' +
      '  <th>DISTRESS</th>' +
      '  <th>IRI</th>' +
      '  <th>RUT</th>' +
      '  <th>FAULT</th>' +
      // '  <th>BEG</th>' +
      // '  <th>END</th>' +
      '</tr>';

      this.historicalCSV = "Inventory, Year, CRS WITH, CRS OPP, DISTRESS WITH, DISTRESS OPP, IRI WITH, IRI OPP, RUT WITH, RUT_OPP, FAULT WITH, FAULT OPP, BEG STA, END STA\n";

      pavementFeatures.forEach((feature, index) => {
        tableStr += 
          '<tr id="FEATURE_' + index + '">' +
          '  <td>' + feature.attributes.CRS_YR + '</td>' +
          '  <td>' + feature.attributes.CRS_WITH.toFixed(1) + '&nbsp;|&nbsp;' +
                     feature.attributes.CRS_OPP.toFixed(1) + '</td>' +
          '  <td>' + feature.attributes.DTRESS_WTH + '&nbsp;|&nbsp;' +
                     feature.attributes.DTRESS_OPP + '</td>' +
          '  <td>' + feature.attributes.IRI_WITH + '&nbsp;|&nbsp;' +
                     feature.attributes.IRI_OPP + '</td>' +
          '  <td>' + feature.attributes.RUT_WITH.toFixed(2) + '&nbsp;|&nbsp;' +
                     feature.attributes.RUT_OPP.toFixed(2) + '</td>' +
          '  <td>' + feature.attributes.FAULT_WITH.toFixed(2) + '&nbsp;|&nbsp;' +
                     feature.attributes.FAULT_OPP.toFixed(2) + '</td>' +
          // '  <td>' + feature.attributes.BEG_STA.toFixed(2) + '</td>' +
          // '  <td>' + feature.attributes.END_STA.toFixed(2) + '</td>' +
          '</tr>';
          this.historicalCSV += 
            feature.attributes.INVENTORY + ',' +
            feature.attributes.CRS_YR + ',' +
            feature.attributes.CRS_WITH.toFixed(1) + ',' +
            feature.attributes.CRS_OPP.toFixed(1) + ',' +
            feature.attributes.DTRESS_WTH + ',' +
            feature.attributes.DTRESS_OPP + ',' +
            feature.attributes.IRI_WITH + ',' +
            feature.attributes.IRI_OPP + ',' +
            feature.attributes.RUT_WITH.toFixed(2) + ',' +
            feature.attributes.RUT_OPP.toFixed(2) + ',' +
            feature.attributes.FAULT_WITH.toFixed(2) + ',' +
            feature.attributes.FAULT_OPP.toFixed(2) + ',' +
            feature.attributes.BEG_STA.toFixed(3) + ',' +
            feature.attributes.END_STA.toFixed(3) + '\n';

      });

      tableStr += '<tr class="export-table-text"><td colspan="6"><strong>Save Table</strong></td></tr>'

      tableStr += '</table>';

      // &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      tableStr += '<input type="button" class="mask-button" value="Save Table" id="exportHistoricalButton"></input>';

      return tableStr;

    } else {
      return "";
    }
  }

  private addHistoricalLinks() {
    try {
      const btns = document.getElementsByClassName("export-table-text");
      for (let i=0; i < btns.length; i++) {
        if (btns[i].innerHTML.substr(0,3) === "<td") {
          const row = btns[i] as HTMLTableRowElement;
          row.onclick = this.downloadCSV.bind(this, this.historicalCSV, this.historicalFilename);
        }

      }
        

    }
    catch (error) {
      console.log("Error in addHistoricalLinks ", error.message)
    }
  }


  // Function to download data to a file
  private downloadCSV(data:string, filename:string) {
    console.log("Saving Historical Table")
    const file = new Blob([data], {type: "txt"});
    if (navigator.msSaveOrOpenBlob) { // IE10+
        navigator.msSaveOrOpenBlob(file, "filename");
    } else { // Others
        const a = document.createElement("a") as HTMLAnchorElement;
        const url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(() => {
          try {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);  
          } catch (error) {
            console.log("Error in downloadCSV setTimeout", error.message);            
          }
        }, 10); 
    }
  }

  private loadPopupTemplate(feature: Graphic, programFeatures?: Graphic[], pavementFeatures?: Graphic[]) {
    try {

      this.historicalFilename = "Road History " + feature.attributes.INVENTORY + " " + feature.attributes.BEG_STA + " to " + feature.attributes.END_STA + ".csv";

      const popupContent:Content[] = [
        new TextContent({
          text: "Inventory Data"
        }),
        new FieldsContent({
          fieldInfos: [
            {
              fieldName: "INVENTORY",
              label: "Key Route"
            },
            // {
            //     fieldName: "OBJECTID",
            //     label: "OBJECTID",
            // },
            {
              fieldName: "FC",
              label: "Functional Class"
            },
            {
              fieldName: "BEG_STA",
              label: "Beg Station"
            },
            {
              fieldName: "END_STA",
              label: "End Station"
            },
            {
              fieldName: "MARKED_RT",
              label: "Marked Route"
            },
            {
              fieldName: "ROAD_NAME",
              label: "Street Name"
            },
            {
              fieldName: "JUR_TYPE",
              label: "Jurisdiction"
            },
            {
              fieldName: "INV_CO",
              label: "County"
            },
            {
              fieldName: "DIST",
              label: "District"
            },
            {
              fieldName: "MUNI",
              label: "Town"
            },
            {
              fieldName: "SURF_YR",
              label: "Surface Year"
            },
            {
              fieldName: "SURF_TYP",
              label: "Surface Type"
            }
          ]
        })
      ];


      if (pavementFeatures && pavementFeatures.length > 0) {
        this.featuresHist = pavementFeatures;

        popupContent.push( 
          new TextContent({
            text: this.getPavementTableFromHistory(pavementFeatures[0])    
          }
        ));

        popupContent.push( 
          new TextContent({
            text: this.getHistoricalPavementTable(pavementFeatures)    
          }
        ));

        popupContent.push(
          new TextContent({
            text: "CRS Chart"
        }));
      } else {
        // If no history, try to use feature data
        this.featuresHist = undefined;
        if (feature && feature.attributes.CRS_YR !== "0000") {
          popupContent.push( 
            new TextContent({
              text: this.getPavementTable(feature)    
            }
          ));
        }
      }

      if (feature && feature.attributes.AADT_YR !== "0000") {
        popupContent.push(
          new TextContent({
            text: "Traffic Count"
          }),
          new FieldsContent({
            fieldInfos: [
              {
                fieldName: "expression/aadt-yr",
                label: "AADT"
              },
              {
                fieldName: "expression/mu-yr",
                label: "MU"
              },
              {
                fieldName: "expression/su-yr",
                label: "SU"
              },
              {
                fieldName: "expression/hcv-yr",
                label: "HCV"
              }
            ]
          },
        ));

        popupContent.push(
          new TextContent({
            text: "Traffic"
        }));
  
      }

      if (programFeatures && programFeatures.length > 0) {
        const programTitle = new TextContent({
          text: "Program Data"
        });
        const programFields = new FieldsContent({
          fieldInfos: [
            {
              fieldName: "ProgramType",
              label: "Program Type"
            },
            {
              fieldName: "PPSProject",
              label: "PPS Number"
            },
            {
              fieldName: "Route",
              label: "Route"
            },
            {
              fieldName: "GISRouteKe",
              label: "Key Route"
            },
            {
              fieldName: "BeginMile",
              label: "Beg Station"
            },
            {
              fieldName: "EndMile",
              label: "End Station"
            },
            {
              fieldName: "Location",
              label: "Location"
            }
          ]
        });
        const programFeature = programFeatures[0];
      
        if (programFeature.hasOwnProperty('sourceLayer')) {
          feature.attributes.ProgramType = programFeature['sourceLayer'].title;
        }
        feature.attributes.PPSProject = programFeature.attributes.PPSProject;
        feature.attributes.Route =
          programFeature.attributes.Route1 +
          (programFeature.attributes.Route2 && programFeature.attributes.Route2.trim()
            ? "\n" + programFeature.attributes.Route2
            : "") +
          (programFeature.attributes.Route3 && programFeature.attributes.Route3.trim()
            ? "\n" + programFeature.attributes.Route3
            : "") +
          (programFeature.attributes.Route4 && programFeature.attributes.Route4.trim()
            ? "\n" + programFeature.attributes.Route4
            : "") +
          (programFeature.attributes.Route5 && programFeature.attributes.Route5.trim()
            ? "\n" + programFeature.attributes.Route5
            : "") +
          (programFeature.attributes.Route6 && programFeature.attributes.Route6.trim()
            ? "\n" + programFeature.attributes.Route6
            : "") +
          (programFeature.attributes.Route7 && programFeature.attributes.Route7.trim()
            ? "\n" + programFeature.attributes.Route7
            : "") +
          (programFeature.attributes.Route8 && programFeature.attributes.Route8.trim()
            ? "\n" + programFeature.attributes.Route8
            : "");
        feature.attributes.GISRouteKe = programFeature.attributes.GISRouteKe;
        feature.attributes.BeginMile = programFeature.attributes.BeginMile;
        feature.attributes.EndMile = programFeature.attributes.EndMile;
        feature.attributes.Location = programFeature.attributes.Location;

        if (programFeature.attributes.Improvem_1) {
          programFields.fieldInfos.push(
            new FieldInfo({
              fieldName: "Improvements",
              label: "Improvements"
          }));
          feature.attributes.Improvements =
            programFeature.attributes.Improvem_1 +
            (programFeature.attributes.Improvem_3 && programFeature.attributes.Improvem_3.trim()
              ? "\n" + programFeature.attributes.Improvem_3
              : "") +
            (programFeature.attributes.Improvem_5 && programFeature.attributes.Improvem_5.trim()
              ? "\n" + programFeature.attributes.Improvem_5
              : "");
        }

        if (programFeature.attributes.EstimatedC) {
          programFields.fieldInfos.push(new FieldInfo({
            fieldName: "EstimatedCost",
            label: "Est. Cost"
          }));
          feature.attributes.EstimatedCost = programFeature.attributes.EstimatedC;
        }

        if (programFeature.attributes.AwardAmoun || programFeature.attributes.AwardAmoun === "") {
          programFields.fieldInfos.push(new FieldInfo({
            fieldName: "AwardAmount",
            label: "Award Amount"
          }));
          feature.attributes.AwardAmount = programFeature.attributes.AwardAmoun;
        }

        if (programFeature.attributes.StructureN) {
          programFields.fieldInfos.push(new FieldInfo({
            fieldName: "Structure",
            label: "Structure"
          }));
          feature.attributes.Structure = programFeature.attributes.StructureN;
        }

        if (programFeature.attributes.FundSource) {
          programFields.fieldInfos.push(new FieldInfo({
            fieldName: "FundSource",
            label: "Funding Source"
          }));
          feature.attributes.FundSource =
            programFeature.attributes.FundSource +
            (programFeature.attributes.FundSour_1 && programFeature.attributes.FundSour_1.trim()
              ? ", " + programFeature.attributes.FundSour_1
              : "") +
            (programFeature.attributes.FundSour_1 && programFeature.attributes.FundSour_2.trim()
              ? ", " + programFeature.attributes.FundSour_2
              : "");
        }

        programFields.fieldInfos.push(new FieldInfo({
          fieldName: "Footnote",
          label: "Footnote"
        }));
        feature.attributes.Footnote =
          programFeature.attributes.Footnote1 +
          (programFeature.attributes.Footnote2 && programFeature.attributes.Footnote2.trim()
            ? "\n" + programFeature.attributes.Footnote2
            : "") +
          (programFeature.attributes.Footnote3 && programFeature.attributes.Footnote3.trim()
            ? "\n" + programFeature.attributes.Footnote3
            : "");

        popupContent.push(programTitle);
        popupContent.push(programFields);
      }

      const iroadsPopupTemplate = new PopupTemplate({
        title: "Data Reporting Tool",
        outFields: ["*"],
        fieldInfos: [
          {
            fieldName: "SU_VOL",
            label: "SU"
          },
          {
            fieldName: "MU_VOL",
            label: "MU"
          },
          {
            fieldName: "expression/aadt-hcv",
            label: "Other"
          },
        ],
        expressionInfos: [
          {
            name: "aadt-yr",
            title: "AADT",
            expression: "Text($feature.AADT) + TextFormatting.Tab + '(' + Text($feature.AADT_YR) + ')'"
          },
          {
            name: "mu-yr",
            title: "MU",
            expression: "Text($feature.MU_VOL) + TextFormatting.Tab + '(' + Text($feature.HCV_MU_YR) + ')'"
          },
          {
            name: "su-yr",
            title: "SU",
            expression: "Text($feature.SU_VOL) + TextFormatting.Tab + '(' + Text($feature.HCV_MU_YR) + ')'"
          },
          {
            name: "hcv-yr",
            title: "HCV",
            expression: "Text($feature.HCV) + TextFormatting.Tab + '(' + Text($feature.HCV_MU_YR) + ')'"
          },
          {
            name: "aadt-hcv",
            title: "Other",
            expression: "$feature.HCV + $feature.AADT"
          },
          {
            name: "traffic-total",
            title: "Traffic Total",
            expression: "$feature.HCV + $feature.AADT + $feature.MU_VOL + $feature.SU_VOL"
          },
          {
            name: "crs",
            title: "CRS",
            expression:
              "Text($feature.CRS_WITH, '#.0') + ' | ' + Text($feature.CRS_OPP, '#.0') + ' | ' + Text($feature.CRS_YR)"
          },
          {
            name: "distress",
            title: "Distress",
            expression: "Text($feature.DTRESS_WTH) + ' | ' + Text($feature.DTRESS_OPP)"
          },
          {
            name: "iri",
            title: "IRI",
            expression: "Text($feature.IRI_WITH) + ' | ' + Text($feature.IRI_OPP) + ' | ' + Text($feature.CRS_YR)"
          },
          {
            name: "rut",
            title: "RUT",
            expression:
              "Text($feature.RUT_WITH, '#.00') + ' | ' + Text($feature.RUT_OPP, '#.00') + ' | ' + Text($feature.CRS_YR)"
          }
        ],
        content: popupContent
      });

      feature.popupTemplate = iroadsPopupTemplate;

      this.view.popup.set({
        features: [feature], // featureSet.features,
        // popupTemplate: iroadsPopupTemplate,
        title: "Data Reporting Tool"
      });

      this.view.popup.visible = true;
      document.body.style.cursor = "default";
      this.toolbar.setPanAsActiveTool();

      watchUtils.whenOnce(this.view.popup, "selectedFeature", (selectedFeature) => {
        // pie chart not working in edge:
        // if (navigator.appVersion.indexOf('Edge') === -1) {
          setTimeout(this.addPieChart.bind(null, feature as Graphic), 1700);
          if (this.featuresHist && this.featuresHist.length > 0) {
            setTimeout(this.addCRSChart.bind(null, this.featuresHist), 1700);
          }
        // }
        setTimeout(this.addSelectLinks.bind(this), 1500);
        setTimeout(this.addHistoricalLinks.bind(this), 1600);
        });
      // this.addPieChart(feature as Graphic);
      // });
    } catch (error) {
      console.error("Error: in loadPopupTemplate " + error.message);
    }
  }
}
